import React from "react";
import {
    Container,
    Card,
    Form,
    Row,
    Col,
    Button,
    Popover,
    OverlayTrigger,
    ProgressBar,
} from "react-bootstrap";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import { MdOutlineHelp } from "react-icons/md";

import { Link } from "react-router-dom";

const popover = (
    <Popover id="popover-basic" className="info_pop">
        <Popover.Body>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus
            dolor aperiam.
        </Popover.Body>
    </Popover>
);

const AddStudent = () => {
    return (
        <div className="dashbrd_pg">
            <SchoolHeader />
            <div className="schl_prfl_pg">
                <Container>
                    <div className="prfl_wrap">
                        <div className="pg_hdng text-center mb-4">
                            <h2>Add Student</h2>
                        </div>
                        <div className="prfl_cntnt">
                            <Card className="pg_card">
                                <Card.Body>
                                    <div className="prfl_flds">
                                        <Form>
                                            <Row>
                                                <Col sm={4} className="mb-3">
                                                    <Form.Label>
                                                        First Name
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Student Name"
                                                    />
                                                </Col>
                                                <Col sm={4} className="mb-3">
                                                    <Form.Label>
                                                        Middle Name
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Middle Name"
                                                    />
                                                </Col>
                                                <Col sm={4} className="mb-3">
                                                    <Form.Label>
                                                        Last Name
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Last Name"
                                                    />
                                                </Col>
                                            </Row>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>
                                                    School Name
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter School Name"
                                                />
                                            </Form.Group>
                                            <Row>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Program
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Company Name"
                                                    />
                                                </Col>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Graduation Date
                                                    </Form.Label>
                                                    {/* <DatePicker
                                                selected={startDate}
                                                onChange={(date: Date) =>
                                                    setStartDate(date)
                                                }
                                            /> */}
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Graduation Date"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Professional Email
                                                        address
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Email address"
                                                    />
                                                </Col>
                                                <Col sm={6}>
                                                    <Form.Label>
                                                        Personal Email address
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Personal Email address"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Phone Number
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Phone Number"
                                                    />
                                                </Col>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Date of Birth
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Date of Birth"
                                                    />
                                                </Col>
                                            </Row>

                                            <Form.Group
                                                className="mb-3"
                                                controlId="exampleForm.ControlTextarea1"
                                            >
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                />
                                            </Form.Group>

                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicEmail"
                                            >
                                                <Form.Label>
                                                    Prior Certifications{" "}
                                                    <OverlayTrigger
                                                        trigger="click"
                                                        placement="right"
                                                        overlay={popover}
                                                    >
                                                        <span className="info_icn">
                                                            <MdOutlineHelp />
                                                        </span>
                                                    </OverlayTrigger>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter Prior Certifications(i.e. CNA, LVN)"
                                                />
                                            </Form.Group>
                                            <Form.Group
                                                controlId="formFile"
                                                className="mb-3"
                                            >
                                                <Form.Label>
                                                    Picture of the front ID
                                                </Form.Label>
                                                <Form.Control type="file" />
                                            </Form.Group>

                                            <Row>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Set New Password
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="Enter New Password"
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Minimum 8 characters, at
                                                        least one alpha,
                                                        special, numeric, upper
                                                        & lower case
                                                    </Form.Text>
                                                </Col>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Label>
                                                        Confirm Password
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="Confirm Password"
                                                    />
                                                </Col>
                                            </Row>

                                            <Link to="/student-info2">
                                                <div className="text-center">
                                                    <Button
                                                        className="btn_theme mt-4"
                                                        type="submit"
                                                        variant=""
                                                    >
                                                        Submit
                                                    </Button>
                                                </div>
                                            </Link>
                                        </Form>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default AddStudent;
